import { callApiWithToken } from './base';
import config from '../../config';

export const fetchPerformanceUnits = async (token: string) =>
  callApiWithToken(`${config.urls.performanceUnits}`, token, 'GET');
